/* stats-carousel.js — count-up animation for statistics_column numbers.
   Original theme loads a deferred statistics-column.js that animates the
   percentages when they scroll into view. Vanilla reimplementation. */
(function () {
  'use strict';

  function init() {
    var section = document.querySelector('.stats-carousel-section');
    if (!section) return;

    var numbers = section.querySelectorAll('[data-stat-number]');
    if (!numbers.length) return;

    var reducedMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion || !('IntersectionObserver' in window)) {
      return; // keep static final values
    }

    var DURATION = 1500; // ms

    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function animateNumber(el) {
      var finalText = el.getAttribute('data-final') || el.textContent.trim();
      var match = finalText.match(/^(\d+)(.*)$/);
      if (!match) return;

      var target = parseInt(match[1], 10);
      var suffix = match[2] || '';
      var start = null;

      el.setAttribute('data-final', finalText);

      function step(timestamp) {
        if (start === null) start = timestamp;
        var progress = Math.min((timestamp - start) / DURATION, 1);
        var value = Math.round(easeOutCubic(progress) * target);
        el.textContent = value + suffix;
        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          el.textContent = finalText;
        }
      }

      el.textContent = '0' + suffix;
      window.requestAnimationFrame(step);
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateNumber(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    numbers.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
